import CryptoList from '../components/body/CryptoList';

function Homepage() {

    return (
        <section>
            <h1>Crypto currency price updates</h1>
            <CryptoList />
        </section>
    )
}

export default Homepage;